import React, { useEffect, useRef, useState } from 'react'
import Button from '../buttons/Button'
import downloadIcon from '../../assets/images/downloadIcon.svg'
import arrowIcon from '../../assets/images/whiteArrowIcon.svg'
import { useExpandableText } from '../../hooks/useExpandableText'
import { CopyIconSvg } from '../ui/Svgs'
import useCopyToClipboard from '../../hooks/useCopyToClipboard'
import { useDispatch, useSelector } from 'react-redux'
import { downloadImage } from '../../utils/helpers'
import { setDownloadImageModal, setIsOpenShareFeedbackModal, setIsOpenTermsAndConditionsModal, setIsOpenViewDetailsModal, updateSingleImageRating } from '../../redux/imageModalSlice'
import { useGenerateImages } from '../../services/imageService'
import ReactGA from "react-ga4";
import disclaimers from '../../assets/images/dangerSvg.svg'
import likeIcon from '../../assets/images/like_icon.svg'
import white_likeIcon from '../../assets/images/white_like_icon.svg'
import dislikeIcon from '../../assets/images/dislike_icon.svg'


import emoji0 from '../../assets/images/noRating.svg'
import emoji1 from '../../assets/images/emoji-1.svg'
import emoji2 from '../../assets/images/emoji-2.svg'
import emoji3 from '../../assets/images/emoji-3.svg'
import emoji4 from '../../assets/images/emoji-4.svg'
import emoji5 from '../../assets/images/emoji-5.svg'
import { updateGeneratedImageFeedback } from '../../redux/createImageSlice'
import { useNavigate } from 'react-router-dom'
import axiosTokenInstance from '../../services/axiosInstance'
import { updateFeedback } from '../../redux/pastCreateionsSlice'
import { showToast } from '../../redux/toasterSlice'



const ViewImageDetails = ({ imageData, openShareFeedback, onCloseViewDetail, }) => {
    const dispatch = useDispatch();
    const generateImages = useGenerateImages();
    const guid = localStorage.getItem("guid")
    const { isImageLoading, generatedImages } = useSelector((state) => state.createImage);

    const { isCopied: isUserPromptCopied, copyToClipboard: copyUserPrompt } = useCopyToClipboard();
    const { isCopied: isMagicPromptCopied, copyToClipboard: copyMagicPrompt } = useCopyToClipboard();
    const { isCopied: isModifiedPrompt, copyToClipboard: copyModifiedPrompt } = useCopyToClipboard();

    const userPrompt = useExpandableText(imageData.prompt, 150);
    const magicPrompt = useExpandableText(imageData.enhancedPrompt, 150);
    const modifiedPrompt = useExpandableText(imageData.instructPrompt, 150);

    const [copiedStates, setCopiedStates] = useState({});
    const [showDisclaimer, setShowDisclaimer] = useState(false);


    const handleDownloadClick = async (e) => {

        onCloseViewDetail()
        dispatch(setDownloadImageModal(true))
        await downloadImage(imageData, `TypeInContext_AI_${imageData.fontFamily}_${imageData.prompt}`);
        console.log("clicked");
        ReactGA.gtag('event', 'download_image', {
            action: `Download image with font family ${imageData.fontFamily}`,
            label: `Prompt: ${imageData.prompt}`
        });
    }

    const handleGetThisFont = () => {
        ReactGA.gtag('event', 'font_redirect', {
            action: 'Redirection to Enterprise',
            label: `https://enterprise.monotype.com/en/family/${imageData?.fontFamilyUrl}`
        });
        window.open(`https://enterprise.monotype.com/en/family/${imageData?.fontFamilyUrl}?utm_source=portrait&utm_medium=${imageData?.md5hash}&utm_campaign=${guid}`, '_blank');
    };

    const emojiList = [emoji0, emoji1, emoji2, emoji3, emoji4, emoji5];
    const handleEmojiChange = emojiList[imageData.rating] || emoji0;

    const disclaimerTimeoutRef = useRef(null);
    const disclaimerRef = useRef(null);
    const iconRef = useRef(null);

    useEffect(() => {
        function handleMouseLeave(event) {
            if (
                disclaimerRef.current &&
                !disclaimerRef.current.contains(event.relatedTarget) &&
                iconRef.current &&
                !iconRef.current.contains(event.relatedTarget)
            ) {
                setShowDisclaimer(false);
            }
        }

        if (showDisclaimer) {
            document.addEventListener('mouseleave', handleMouseLeave);
        }

        return () => {
            document.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [showDisclaimer]);



    const handleMouseEnter = () => {
        if (disclaimerTimeoutRef.current) {
            clearTimeout(disclaimerTimeoutRef.current);
        }
        setShowDisclaimer(true);
    };

    const handleMouseLeave = () => {
        disclaimerTimeoutRef.current = setTimeout(() => {
            setShowDisclaimer(false);
        }, 200);
    };

    const handleLikeDislikeIconClick = async (identifier) => {
        const feedbackData = {
            _id: imageData._id,
            rating: identifier === 'like' ? 5 : 1,
        };
        try {
            
            const response = await axiosTokenInstance.post(`/feedback`, feedbackData);
            if (response.status === 201) {
                dispatch(
                    showToast({
                        message: 'Your feedback has been shared successfully',
                        type: 'success',
                    }),
                );
                dispatch(setIsOpenViewDetailsModal(false));
                dispatch(updateSingleImageRating({ rating: feedbackData.rating, comment: feedbackData.comment }))
                dispatch(updateGeneratedImageFeedback({ feedbackData }))
                dispatch(updateFeedback({ promptId: imageData.promptId, feedbackData }));
            }
            ReactGA.gtag('event', 'feedback_submit', {
                action: 'Feedback submitted ',
                label: `Average rating:${feedbackData.rating}`,
                value: feedbackData.rating
            });
        } catch {
            dispatch(
                showToast({
                    message: 'Failed to submit feedback. Try again.',
                    type: 'error',
                }),
            );
        }
    }

    return (
        <div className='h-[492px] w-[776px] p-[40px] flex gap-[24px]'>
            <img className='h-[412px] w-[294px] object-cover rounded-[24px]' src={imageData?.thumbnailImage ?
                `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.thumbnailImage}`
                : `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.images}`} alt="" />
            <div className='h-[412px] w-[378px] flex flex-col gap-[24px]'>
                <div className='flex flex-col gap-[4px]'>
                    <span className='text-secondary leading-[24px] tracking-[-0.02em]'>Font used</span>
                    <h2 className='text-[28px] font-helveticaText-Bold leading-[32px] tracking-[-0.01em] text-cus_primary font-[700] '>{imageData.fontFamily}</h2>
                </div>
                <div className='flex-grow flex flex-col gap-[24px] py-[24px] pr-[20px] border-y overflow-y-scroll hidden-scrollbar'>
                    <div className='flex flex-col gap-[4px]'>
                        <div className='small-texts text-secondary font-[400] leading-[16px] flex items-center justify-between'>
                            <span>Prompt used</span>
                            <CopyIconSvg onClick={() => copyUserPrompt(imageData.prompt)} fill={`${isUserPromptCopied ? '#1A73E8' : '#1E242C'}`} className="cursor-pointer" />
                        </div>
                        <p className='text-cus_primary leading-[24px] tracking-[-0.02em] font-helveticaText-Medium font-[500] text-wrap'>
                            {userPrompt.displayText}<br />
                            {imageData?.prompt.length > 150 && (
                                <span onClick={userPrompt.toggleExpand} className='text-blue-primary cursor-pointer'>
                                    {userPrompt.isExpanded ? 'Show Less' : 'Know More'}
                                </span>
                            )}
                        </p>
                    </div>
                    {imageData.instructPrompt &&
                        <div className='flex flex-col gap-[4px]'>
                            <div className='small-texts text-secondary font-[400] leading-[16px] flex items-center justify-between'>
                                <span>Updated Prompt</span>
                                <CopyIconSvg onClick={() => copyModifiedPrompt(imageData.instructPrompt?.replace(/<IT>/g, '').trim())} fill={`${isModifiedPrompt ? '#1A73E8' : '#1E242C'}`} className="cursor-pointer" />
                            </div>
                            <p className='text-cus_primary leading-[24px] tracking-[-0.02em] font-helveticaText-Medium font-[500] text-wrap'>
                                {modifiedPrompt?.displayText?.replace(/<IT>/g, '').trim()}<br />
                                {imageData.instructPrompt > 150 && (
                                    <span onClick={modifiedPrompt.toggleExpand} className='text-blue-primary cursor-pointer'>
                                        {modifiedPrompt.isExpanded ? 'Show Less' : 'Know More'}
                                    </span>
                                )}
                            </p>
                        </div>
                    }
                    <div className='flex flex-col gap-[4px]'>
                        <div className='small-texts text-secondary font-[400] leading-[16px] flex items-center justify-between'>
                            <span> Magic prompt used</span>
                            <CopyIconSvg onClick={() => copyMagicPrompt(imageData.enhancedPrompt)} fill={`${isMagicPromptCopied ? '#1A73E8' : '#1E242C'}`} className="cursor-pointer" />
                        </div>
                        <p className='text-cus_primary font-[400] leading-[24px] tracking-[-0.02em]'>
                            {magicPrompt.displayText}<br />
                            {imageData.enhancedPrompt.length > 150 && (
                                <span onClick={magicPrompt.toggleExpand} className='text-blue-primary cursor-pointer'>
                                    {magicPrompt.isExpanded ? 'Show Less' : 'Know More'}
                                </span>
                            )}
                        </p>
                    </div>
                </div>
                <div className='flex items-center gap-[24px]'>
                    <Button label='Get this font' className='h-[40px] bg-blue-primary flex items-center gap-[8px] text-white small-texts font-[500]' onClick={handleGetThisFont} >
                        <span>Get this font</span>
                        <img src={arrowIcon} alt="arrow icon" />

                    </Button>
                    {/* {location.pathname === '/generate-image' &&
                        <button disabled={isImageLoading}>
                            <img src={smartStartIcon} onClick={handleGenerateVisualsClick} alt="smart start icon" className={`h-[20px] w-[24px]  cursor-pointer aspect-auto ${isImageLoading && 'opacity-50 cursor-not-allowed'}`} />
                        </button>
                    } */}
                    <div
                        ref={iconRef}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        className={`h-[32px]  w-[32px] flexCenter rounded-[8px] ${showDisclaimer && 'border-1 border-[#DC5800] '} `}
                    >
                        <img src={disclaimers} alt="disclamer" className='h-[21px] w-[21px] cursor-pointer' />
                    </div>
                    {showDisclaimer && (
                        <div
                            ref={disclaimerRef}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            className={`shadow-xl w-[384px] bg-white p-[40px] absolute z-[9999] top-[90px] right-[230px] rounded-lg flex flex-col gap-[24px]`}
                        >
                            <h2 className="text-[24px] leading-[32px] text-[#1E242C] font-helveticaText-Medium">Disclaimer</h2>
                            <div className="flex flex-col gap-[16px]">
                                <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify hyphens-auto' >AI-generated visualizations aim to closely replicate original fonts; however, slight variations may occur.</h5>
                                <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify' >
                                    Portrait is designed to inspire users by showing how fonts look in visual settings. The main text reflects the chosen font, while smaller text may appear unreadable.
                                    Please refer to our  <a href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-blue-primary '>terms and conditions</a> for more details on image usage guidelines.
                                </h5>
                            </div>
                        </div>
                    )}
                    <div className={`h-[32px] w-[32px] flexCenter rounded-[8px] cursor-pointer hover:border-[2px] `}
                    >
                        <img onClick={handleDownloadClick} src={downloadIcon} alt="download icon" className='h-[24px] cursor-pointer aspect-auto text-gray-primary ' />
                    </div>
                    {/* <img onClick={handleFeedbackIconClick} src={imageData.rating > 0 ? filledStarIcon : starIcon} alt="smart start icon" className='h-[24px] cursor-pointer aspect-auto text-gray-primary' /> */}
                    {/* <StarIconSvg onClick={handleFeedbackIconClick} fill={`${imageData.rating > 0 ? '#F2B500' : 'white'}`} strokeColor={`${imageData.rating > 0 ? '#F2B500' : '#667488'}`} className='cursor-pointer' /> */}
                    {/* <img onClick={handleFeedbackIconClick} src={handleEmojiChange} alt="" className='h-[24px] w-[24px] cursor-pointer' /> */}
                    <div onClick={() => {imageData.rating !== 5 && handleLikeDislikeIconClick("like")}}
                        className={`h-[32px] w-[32px] ${imageData.rating > 1 ? 'bg-[#1A73E8]' : 'bg-white hover:border-[2px]'}  flexCenter rounded-[8px] cursor-pointer `}
                    >
                        <img src={imageData.rating > 1 ? white_likeIcon : likeIcon} alt="" />
                    </div>
                    <div
                        onClick={() => {imageData.rating !== 1 && handleLikeDislikeIconClick("dislike")}}
                        className={`h-[32px] w-[32px] ${imageData.rating === 1 ? 'bg-[#1A73E8] ' : 'bg-white hover:border-[2px]'} flexCenter rounded-[8px] cursor-pointer `}
                    >
                        <img src={imageData.rating === 1 ? white_likeIcon : dislikeIcon} alt="" className={`${imageData.rating === 1 && 'rotate-180'}`} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewImageDetails